import * as React from "react";
import { FC } from "react";
import Draggable from "react-draggable";
import Portal from "./Portal";
import "./Popup.scss";

export interface IPopupProps {
    id: string;
    isMobile: boolean;
    hasBackdrop?: boolean;
    className?: string;
    defaultPosition?: { x: number; y: number };
    notDraggable?: boolean;
    sameContainer?: boolean;
}

export const Popup: FC<IPopupProps> = (props) => {
    return props.isMobile ? (
        <div id={props.id} className="popup">
            <div className="container shadow">{props.children}</div>
        </div>
    ) : props.sameContainer ? (
        <div className="popup">
            {props.hasBackdrop && <div className={"popup-backdrop-relative"}></div>}
            <div className={"popup-container " + props.className}>
                <div className="popup-content shadow">{props.children}</div>
            </div>
        </div>
    ) : (
        <Portal id={props.id}>
            {props.hasBackdrop && <div className={"popup-backdrop"}></div>}
            <div className={"popup-container " + props.className}>
                {props.notDraggable ? (
                    <div className="popup-content shadow">{props.children}</div>
                ) : (
                    <Draggable
                        axis="both"
                        bounds="parent"
                        handle=".popup-header"
                        defaultPosition={props.defaultPosition || { x: 0, y: 0 }}
                    >
                        <div className="popup-content shadow">{props.children}</div>
                    </Draggable>
                )}
            </div>
        </Portal>
    );
};

export const PopupHeader: FC<{ isMobile: boolean; children?: React.ReactNode }> = (props) => {
    return props.isMobile ? (
        <div className="header">{props.children}</div>
    ) : (
        <div className="popup-header">
            <div className="popup-header-container">{props.children}</div>
        </div>
    );
};

export const PopupBody: FC<{ isMobile: boolean; children?: React.ReactNode }> = (props) => {
    return props.isMobile ? (
        <div className="content">{props.children}</div>
    ) : (
        <div className="popup-body">
            <div className="body-container">{props.children}</div>
        </div>
    );
};

export const PopupFooter: FC<{ isMobile: boolean; children?: React.ReactNode }> = (props) => {
    return props.isMobile ? (
        <div className="footer">{props.children}</div>
    ) : (
        <div className="popup-footer" draggable={true}>
            <div className="popup-footer-container">{props.children}</div>
        </div>
    );
};
